import { Input, Form } from "antd";
import ContentPadding from "../ContentConfig/ContentPadding";

export default () => {
  return (
    <>
      <ContentPadding />
      <Form.Item
        label={"common.link"}
        name="qrcodeUrl"
        rules={[
          {required: true},
          {type: "url", message: "form.url.invalid"},
          {max: 2000, message: "form.input.max_length" },
        ]}
      >
        <Input />
      </Form.Item>
    </>
  );
};
